import React from 'react';
import PropTypes from 'prop-types';

import Dropdown from '../../../react-shared/Dropdown.jsx';

import { daysPropType } from '../propTypes';
import isoToDate from '../../../utils/isoToDate.js';

function DaySelector({
  currentDay, currentTimezone, days, setCurrentDay, logoAlt, logoText, logoUrl, sideImage, todayDate,
}) {
  const formatDate = (date) => isoToDate(date, currentTimezone);

  if (currentDay === 'shared') {
    const buttonBack = (
      <button
        className="c-event-schedule__button-back"
        onClick={() => setCurrentDay(todayDate)}
        onKeyDown={() => setCurrentDay(todayDate)}
        tabIndex={0}
        type="button"
      >
        Back to event&apos;s schedule
      </button>
    );

    return (
      <>
        <section className="o-section c-event-schedule__header u-hide-at-large">
          <div className="o-col o-col--10-at-small o-col--offset-1-at-small">
            <div className="o-col__inner c-event-schedule__header-content">
              {buttonBack}
            </div>
          </div>
        </section>

        <section
          className="c-event-schedule__sidebar c-side-images js-side-images u-show-at-large"
          style={sideImage ? { backgroundImage: `url('${sideImage}')` } : {}}
        >
          <div className="c-event-schedule__sidebar-content">
            {buttonBack}
          </div>
        </section>
      </>
    );
  }

  const dropdownItems = [
    ...days
      .filter((day) => day.events)
      .map((day) => ({ id: day.date, label: formatDate(day.date) })),
    { id: 'saved', label: 'Saved Events' },
  ];

  const sidebarItems = [
    ...days
      .filter((day) => day.events)
      .map((day) => {
        const date = formatDate(day.date).split(',');

        return {
          id: day.date,
          label: date[0],
          sublabel: `${date[1]}, ${date[2]}`,
        };
      }),
    { id: 'saved', label: 'Saved Events', sublabel: 'Plan your Grand Prix trip and share with friends!' },
  ];

  return (
    <>
      <section className="o-section c-event-schedule__header u-hide-at-large">
        <div className="o-col o-col--10-at-small o-col--offset-1-at-small">
          <div className="o-col__inner c-event-schedule__header-content">
            <div className="c-event-schedule__header-logo-group">
              <img src={logoUrl} alt={logoAlt} />
              {logoText && <span>{logoText}</span>}
            </div>

            <Dropdown
              changeHandler={(id) => setCurrentDay(id)}
              id="day-selector"
              items={dropdownItems}
              selectedItems={currentDay}
            />
          </div>
        </div>
      </section>

      <section
        className="c-event-schedule__sidebar c-side-images js-side-images u-show-at-large"
        style={sideImage ? { backgroundImage: `url('${sideImage}')` } : {}}
      >
        <div className="c-event-schedule__sidebar-content">
          <span className="c-event-schedule__sidebar-title">Dates</span>

          {sidebarItems.map((item) => (
            <button
              className={`
                c-event-schedule__sidebar-button
                ${currentDay === item.id ? 'c-event-schedule__sidebar-button--current' : ''}
              `}
              key={item.id}
              onClick={() => setCurrentDay(item.id)}
              onKeyDown={() => setCurrentDay(item.id)}
              type="button"
            >
              <h4 className="c-event-schedule__sidebar-button-day">
                {item.label}
              </h4>

              <span className="c-event-schedule__sidebar-button-date 123">
                {item.sublabel}
              </span>
            </button>
          ))}
        </div>
      </section>
    </>
  );
}

DaySelector.propTypes = {
  currentDay: PropTypes.string.isRequired,
  currentTimezone: PropTypes.string.isRequired,
  days: daysPropType.isRequired,
  logoAlt: PropTypes.string.isRequired,
  logoText: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  setCurrentDay: PropTypes.func.isRequired,
  sideImage: PropTypes.string.isRequired,
  todayDate: PropTypes.string.isRequired,
};

export default DaySelector;
